import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTutorialContext } from '../context/TutorialContext';

export function useTutorialWithNavigation() {
  const navigate = useNavigate();
  const { setTutorialActions, setCurrentStepIndex, pauseTutorial, closeTutorial } = useTutorialContext();

  useEffect(() => {
    const handleCreateSalesPage = () => {
      navigate("/onboarding");
      setCurrentStepIndex(1);
    };

    const handleChooseOption = () => {
      pauseTutorial();
    };

    const handleOrderBump = () => {
      pauseTutorial();
    };

    const handleUpsell = () => {
      pauseTutorial();
    };

    const handleSalesAngles = () => {
      pauseTutorial();
    };

    const handleSummaryTutorialCreateSalesPage = () => {
      closeTutorial();
    };

    const tutorialActions: Record<string, () => void> = {
      createSalesPage: handleCreateSalesPage,
      chooseOption: handleChooseOption,
      orderBump: handleOrderBump,
      upsell: handleUpsell,
      salesAngles: handleSalesAngles,
      summaryTutorialCreateSalesPage: handleSummaryTutorialCreateSalesPage,
    };

    setTutorialActions(tutorialActions);
  }, [navigate, setTutorialActions]);
}
